import axiosapi from "./axiosAPI";

// Get All MarriageTypes
export const getAllMarriageTypes = async (
    setMarriageTypes,
    setFetcherror,

) => {
    
	try{
		const res =await axiosapi.get("/marriagetypes");
        setMarriageTypes(res.data.data ? res.data.data : {});
        

	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch MarriageTypes");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch MarriageTypes");
		}
		
	}
	
};



// Get One MarriageType
export const getOneMarriageType = async (
    pkid,
    setFetcherror,  
    setMarriageType
    
)=>{
	try{
		const res =await axiosapi.get(`/marriagetypes/${pkid}`);
        setMarriageType(res.data.body);
       
	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch MarriageType");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch MarriageType");
		}
		
	}
	
};


// Create New MarriageType
export const createMarriageType = async (
    marriageType,
    setMarriageType,
    setFetcherror,
    handleAllToasts,
    setMarriageTypes

) => {

    if (!marriageType ) {
        handleAllToasts(2, "No MarriageType Provided"); 
            return; 
        }

    const PushItem = {
            name: marriageType,
        };

    try{
        await axiosapi.post("/marriagetypes/",PushItem );
        setMarriageType("");
        handleAllToasts(1, "MarriageType Created Successfully");
        getAllMarriageTypes(setMarriageTypes,setFetcherror);
    }
    catch(err){
        if(err.response){
            //Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Could Not Create New MarriageType");
            handleAllToasts(2, "Could Not update The MarriageType");
            
            
        }else{
            //No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Could Not Create New MarriageType");
            handleAllToasts(2, "Could Not update The MarriageType");
            
        }
        
    }
    
}


// Edit Existing MarriageType

export const editMarriageType = async (
    marriageTypepkid,
    marriageType,
    setMarriageType,
    setFetcherror,
    handleAllToasts,
    setMarriageTypes
              
        ) => {

            if (!marriageType) {
                handleAllToasts(2, "No MarriageType Name Provided"); 
                    return;  
                }

            const PushItem = {

                    id:marriageTypepkid,
                    name: marriageType,
                };

            try{
                await axiosapi.patch("/marriagetypes/",PushItem );
                setMarriageType("");
                handleAllToasts(1, "MarriageType Updated Successfully");
                getAllMarriageTypes(setMarriageTypes,setFetcherror);
            }
            catch(err){
                if(err.response){
                    //Error Obtained from Backend not in 200
                    console.log(err.response.data);
                    console.log(err.response.status);
                    console.log(err.response.headers);
                    setFetcherror("Could Not Update MarriageType");
                    handleAllToasts(2, "Could Not Update MarriageType");
                    
                    
                }else{
                    //No response Obtained from the server.
                    console.log(`Error: ${err.message}`);
                    setFetcherror("Could Not Update MarriageType");
                    handleAllToasts(2, "Could Not Update MarriageType");
                    
                }
                
            }
            
};



// Delete Existing MarriageType.

export const deleteMarriageType = async (
    marriageTypepkid,
    setMarriageTypes,
    setFetcherror,
    handleAllToasts
)=>{
    try {
        const res = await axiosapi.delete(`/marriagetypes/${marriageTypepkid}`);
        let finalData = res.data.message;
        getAllMarriageTypes(setMarriageTypes, setFetcherror);
        handleAllToasts(1, "MarriageType Deleted Successfully");
        console.log("Deleted:", finalData);
        getAllMarriageTypes(setMarriageTypes,setFetcherror);
        
    }
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
			console.log(err.response.data);
			console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Delete MarriageType");
            handleAllToasts(2,"Error: Could Not Delete MarriageType");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Delete MarriageType");
            handleAllToasts(2,"Error: Could Not Delete MarriageType");
		}
		
	}
	
};